module.exports = "<div class=modal-header> <h3 class=modal-title>Check artist availability</h3> </div> <div class=\"modal-body background-light\"> <ink-availability type=\"'check'\"></ink-availability> </div> <div class=modal-footer> <button class=\"button large alert-btn\" type=button ng-click=$ctrl.close()>Close</button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./components/schedule/check-availability/check-availability.html
// module id = ./components/schedule/check-availability/check-availability.html
// module chunks = 0